"use strict";
/*
 * Created on 14. 1. 2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Radek Beran
 */


var RegularProductPriceConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(RegularProductPriceConverter, _DataObjectConverter_);

  function RegularProductPriceConverter() {
    _classCallCheck(this, RegularProductPriceConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(RegularProductPriceConverter).apply(this, arguments));
  }

  return RegularProductPriceConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.RegularProductPriceConverter = RegularProductPriceConverter;